<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useVueInject } from '@/hooks/vue'
import { GlobalStoreKey, GlobalStore } from '@/stores/global'
import { photogoodsListStoreKey, PhotogoodsListStore } from '@/stores/common/photogoodsList'
import { useStates } from '.'
import DefaultTemplate from '@/components/templates/common/DefaultTemplate/index.vue'
import PhotogoodsListContent from '@/components/organisms/common/PhotogoodsListContent/index.vue'

const globalStore = useVueInject<GlobalStore>(GlobalStoreKey)
const photogoodsListStore = useVueInject<PhotogoodsListStore>(photogoodsListStoreKey)
const states = useStates()

onBeforeMount(async () => {
  await Promise.all([
    globalStore.getUsersRole(),
    globalStore.getPref(),
    globalStore.getCategories(),
    photogoodsListStore.getPhotogoods(),
  ])
  states.isApiCallsCompleted = true
})
</script>

<template>
  <DefaultTemplate
    v-if="states.isApiCallsCompleted === true"
    :breadcrumbs="[
      {
        label: 'フォトグッズ',
        path: '/photogoods',
      },
    ]"
    :pref="globalStore.state.pref"
    :categories="globalStore.state.categories"
    :user-role="globalStore.state.userRole"
  >
    <PhotogoodsListContent :products="photogoodsListStore.state.products" />
  </DefaultTemplate>
</template>
